import React, { FC } from 'react'
import { FixedZIndex } from 'src/modules/const'
import { Button } from '../lib/button'
import { Badge } from '../lib/curon-icon'
import SvgTune from '../lib/curon-icon/Tune'
import { View } from '../lib/view'

type Props = {
  onClick: () => void
  displayBadge: boolean
}

export const ServiceTageFilterButton: FC<Props> = ({
  onClick,
  displayBadge,
}) => {
  return (
    <View
      height={'56px'}
      width={'56px'}
      position={'fixed'}
      bottom="30px"
      right={'16px'}
      zIndex={FixedZIndex.header}
      onClick={onClick}
    >
      {displayBadge && (
        <Badge
          position="absolute"
          right="-2px"
          size="20px"
          color="#2BA168"
          strokeWidth={0}
        />
      )}

      <Button
        shape="round"
        colorStyle="white"
        borderRadius={'50%'}
        boxShadow={
          '0px 1px 5px 0px rgba(0, 0, 0, 0.08), 0px 1px 12px 0px rgba(0, 0, 0, 0.16)'
        }
        style={{ border: '2px solid #2BA168' }}
      >
        <SvgTune />
      </Button>
    </View>
  )
}
